import styled, { css, keyframes } from "styled-components/macro";
import { CellProps } from "./Cell";
import { TableProps } from "./Table";

const appearIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
export const StyledTable = styled.table<TableProps>(({ theme, width }) => {
  return css`
    width: ${width ? width : "unset"};
    border-spacing: 0;
    font-size: ${theme.rem(1)};
    margin-bottom: ${theme.rem(1)};
    empty-cells: show;
  `;
});
export const StyledTableRow = styled.tr(({ theme }) => {
  return css``;
});

export const StyledTableCell = styled.td<CellProps>(
  ({ theme, align, highlight, level, alert, width = "auto", animate = true }) => {
    const titleCss = css`
      font-weight: ${theme.values.fontWeight.bold};
    `;
    const upperCss = css`
      text-transform: uppercase;
    `;
    const subTitleCss = css`
      padding-left: ${theme.rem(1.5)};
      position: relative;
      z-index: 1;
    `;
    const animationCss = css`
      opacity: 0;
      animation: ${appearIn} 300ms forwards;
      animation-delay: 300ms;
    `;
    return css`
      background-color: ${highlight
        ? theme.values.colors.global.greys.second
        : theme.values.colors.global.greys.first};
      width: ${width};
      text-align: ${align || "left"};
      padding: ${theme.rem(0.5)};
      border-bottom: 1px solid ${theme.values.colors.global.greys.third};

      /* next styling with alert variable is currently related to abnormalities */
      svg,
      svg * {
        ${alert && `fill: red;`}
      }
      ${alert && `color: red;`}
      ${animate && animationCss}
      ${(level === "title" || level === "upper") && titleCss}
      ${level === "upper" && upperCss}
      ${level === "subTitle" && subTitleCss}

      &:hover {
        z-index: 2;
      }
    `;
  }
);
